import Image from "next/legacy/image";
import classes from "../styles/blog.module.css";
import { useRouter } from "next/router";
import { trackEvent } from "@utils/analytics/event-analytics";
import { WEB_ENGAGE } from "@utils/constants";
function BlogCategoryCard({
  pujaCategory
}) {
  const router = useRouter();
  function clickHandler(categoryUrl, categoryName) {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.HOME_BLOG + " " + WEB_ENGAGE.ITEM_NAMES.BLOG_CATEGORY + " " + WEB_ENGAGE.EVENT_NAMES.ITEM_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.HOME_BLOG,
      [WEB_ENGAGE.EVENT_PROPERTIES.ITEM_NAME]: WEB_ENGAGE.ITEM_NAMES.BLOG_CATEGORY,
      [WEB_ENGAGE.EVENT_PROPERTIES.BLOG_CATEGORY_NAME]: categoryName
    });
    router.push(`/blog/${categoryUrl}`);
  }
  return <div className={classes.blogCategoryCard} onClick={() => clickHandler(pujaCategory?.blogCategoryUrlExtension, pujaCategory?.categoryName)} data-sentry-component="BlogCategoryCard" data-sentry-source-file="blogCategoryCard.jsx">
      <div className={classes.blogCategoryImage}>
        <Image src={pujaCategory?.categoryImage} alt="categoryImage" height={130} width={100} placeholder="blur" blurDataURL={pujaCategory?.categoryImage} data-sentry-element="Image" data-sentry-source-file="blogCategoryCard.jsx" />
      </div>
      {/* <div className={classes.blogCategoryTextSection}>
        <h3 className={`${classes.blogPara } ${classes.noCopy}`}>{pujaCategory?.categoryName}</h3>
       </div> */}
    </div>;
}
export default BlogCategoryCard;